export enum FillStpType {
  STP_ALL,
  STP_NONE,
  STP_AS_NEEDED,
}

export namespace FillStpType {
  let elements = [FillStpType.STP_ALL, FillStpType.STP_NONE, FillStpType.STP_AS_NEEDED];
  let alias = "com.bcdfx.model.FillStpType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
